import { EventEmitter, Component, ChangeDetectorRef, Input, Output, Directive, ElementRef, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SVG } from '@svgdotjs/svg.js';

/**
 * Import Angular libraries.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

function SvgContainerComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵlistener("dblclick", function SvgContainerComponent_div_1_Template_div_dblclick_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.onPointDoubleClick()); })("click", function SvgContainerComponent_div_1_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.onPointClick()); })("mousemove", function SvgContainerComponent_div_1_Template_div_mousemove_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r4.onPointHover()); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleProp("width", ctx_r0.pointSize, "px")("height", ctx_r0.pointSize, "px")("left", ctx_r0.pointXCoordinate, "px")("top", ctx_r0.pointYCoordinate, "px");
} }
const _c0 = ["*"];
class SvgContainerComponent {
    /**
     * Create SVG Container component instance.
     * @param cdRef - Change Detector Ref object instance.
     */
    constructor(cdRef) {
        this.cdRef = cdRef;
        this.mouseInContainer = false;
        this._triggerCoordinateChange = false;
        this.height = 200; // Height of the container.
        this.showGrid = false; // Indicator if grid image should be shown in the background of svg container.
        this.grid = {
            width: 10,
            height: 10,
            strokeColor: 'black'
        }; // Grid object based on which the grid for the svg will be constructed
        this.hoverable = false; // Indicator if user should be able to see dot on hover, to capture coordinates.
        this.pointSize = 10; // Numeric value in pixels, to indicate how large should the point be.
        this.viewBox = []; // Viewbox of the container, must be an array consisting of 4 integers [x, y, width, height].
        /**
         * Output variables used within the component.
         */
        this.clickEvent = new EventEmitter(); // Event handler for retrieving coordinates at clicked position
        this.doubleClickEvent = new EventEmitter(); // Event handler for retrieving coordinates at position where you double-click.
        this.mouseOverEvent = new EventEmitter(); // Event handler when mouse is moved over the container.
        this.mouseOutEvent = new EventEmitter(); // Event handler when the mouse exits the container.
        this.mouseMoveEvent = new EventEmitter();
        // Event handler when the mouse is being moved on the container.
        this.onInitialize = new EventEmitter();
    }
    /**
     * Does all required pre-requisites when input variables changes.
     * @param changes - Changes object containing input variable changes for the container.
     */
    ngOnChanges(changes) {
        // Check if svg container is defined
        if (this._svg) {
            // Check if viewbox has changed
            if (changes.viewBox && changes.viewBox.currentValue !== changes.viewBox.previousValue) {
                // Let's update viewbox value
                this.viewBox = changes.viewBox.currentValue;
                // Let's update viewbox
                this.updateViewbox();
            }
            // Let's update the height
            if (changes.height && changes.height.currentValue !== changes.height.previousValue) {
                // Update height
                this.height = changes.height.currentValue;
                // Update height of the svg container
                this._svg.size('100%', this.height);
            }
            // Let's update pattern in case grid was changed
            if (changes.showGrid || changes.grid) {
                // Update values
                this.grid = changes.grid ? changes.grid.currentValue : this.grid;
                this.showGrid = changes.showGrid ? changes.showGrid.currentValue : this.showGrid;
                // Let's update the pattern
                this.setGridPattern();
            }
            // Check if any other input variables have changed
            if (changes.hoverable && changes.hoverable.currentValue !== changes.hoverable.previousValue ||
                changes.pointSize && changes.pointSize.currentValue !== changes.pointSize.previousValue) {
                // Update values
                this.hoverable = changes.hoverable ? changes.hoverable.currentValue : this.hoverable;
                this.pointSize = changes.pointSize ? changes.pointSize.currentValue : this.pointSize;
                // Let's refresh the view
                this.cdRef.detectChanges();
            }
        }
    }
    /**
     * Does all required pre-requisites before initializing the component.
     */
    ngAfterViewInit() {
        this.setContainer(this.containerId);
    }
    /**
     * Retrieves container instance.
     * @returns SVG Container instance.
     */
    getContainer() {
        return this._svg;
    }
    /**
     * Does all required pre-requisites and adjusts hoverable point position.
     * @param event - Mouse event handler from the DOM.
     */
    adjustPointPosition(event) {
        // Return if we don't have hoverable enabled
        if (!this.hoverable) {
            return;
        }
        // Set correct point coordinates
        if (this._triggerCoordinateChange) {
            this.pointXCoordinate = event.offsetX - this.pointSize / 2;
            this.pointYCoordinate = event.offsetY - this.pointSize / 2;
        }
        // Trigger coordinate change
        this._triggerCoordinateChange = true;
    }
    /**
     * Adjust the mouse move position, and sends out to the user.
     * @param event - Mouse event handler from the DOM.
     */
    adjustMouseMovePosition(event) {
        if (this.hoverable && this._triggerCoordinateChange) {
            this.mouseMoveEvent.emit({
                x: this.pointXCoordinate + this.pointSize / 2,
                y: this.pointYCoordinate + this.pointSize / 2
            });
        }
        else if (!this.hoverable) {
            this.mouseMoveEvent.emit({
                x: event.offsetX,
                y: event.offsetY
            });
        }
    }
    /**
     * Does all required pre-requisites when hovered point is clicked.
     */
    onPointClick() {
        // Indicate that single click has happened.
        this._singleClickHappened = true;
        // Assign coordinates
        const x = this.pointXCoordinate + this.pointSize / 2;
        const y = this.pointYCoordinate + this.pointSize / 2;
        // Set timeout, to make sure we cancel it if double-click happens.
        setTimeout(() => {
            if (this._singleClickHappened) {
                this.clickEvent.emit({ x, y });
            }
        }, 250);
    }
    /**
     * Does all required pre-requisites when hovered point is double clicked.
     */
    onPointDoubleClick() {
        // Let's fire double click event
        this.doubleClickEvent.emit({
            x: this.pointXCoordinate + this.pointSize / 2,
            y: this.pointYCoordinate + this.pointSize / 2
        });
        // Let's set that double click has happened
        this._singleClickHappened = false;
    }
    /**
     * Make sure that we don't trigger coordinate change, if we hover point.
     */
    onPointHover() {
        this._triggerCoordinateChange = false;
    }
    /**
     * Does all required pre-requisites and updates the viewbox of the svg container.
     */
    updateViewbox() {
        // Check if we are still using viewbox
        if (this.viewBox.length === 4) {
            // Set viewbox
            this._svg.viewbox(this.viewBox[0], this.viewBox[1], this.viewBox[2], this.viewBox[3]);
        }
        else {
            // Remove viewbox
            this._svg.viewbox();
        }
    }
    /**
     * Sets a container instance.
     * @param id - ID of the container.
     */
    setContainer(id) {
        // Assign viewbox only if it's defined
        if (this.viewBox && this.viewBox.length === 4) {
            this._svg = SVG()
                .addTo(`#${id}`)
                .size('100%', this.height)
                .viewbox(this.viewBox[0], this.viewBox[1], this.viewBox[2], this.viewBox[3]);
        }
        else {
            this._svg = SVG()
                .addTo(`#${id}`)
                .size('100%', this.height);
        }
        // Let's set pattern if grid and showGrid is set
        if (this.showGrid) {
            this.setGridPattern();
        }
        // Let's output the svg container element
        this.onInitialize.emit(this._svg);
    }
    /**
     * Does all required pre-requisites and initializes or updates grid pattern.
     */
    setGridPattern() {
        // Let's remove old pattern if we have created one
        if (this._pattern) {
            this._pattern.remove();
        }
        // Let's remove old grid if we have created one
        if (this._grid) {
            this._grid.remove();
        }
        // Let's check if we want to show grid
        if (this.showGrid) {
            // Let's create the pattern
            this._pattern = this._svg
                .pattern(this.grid.width, this.grid.height, (addedPattern) => {
                addedPattern
                    .rect(this.grid.width, this.grid.height)
                    .fill('transparent')
                    .stroke(this.grid.strokeColor);
            });
            // Let's create grid
            this._grid = this._svg
                .rect()
                .size('100%', '100%')
                .fill(this._pattern);
        }
    }
}
SvgContainerComponent.ɵfac = function SvgContainerComponent_Factory(t) { return new (t || SvgContainerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
SvgContainerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SvgContainerComponent, selectors: [["svg-container"]], inputs: { height: "height", showGrid: "showGrid", grid: "grid", hoverable: "hoverable", pointSize: "pointSize", viewBox: "viewBox", containerId: "containerId" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", mouseMoveEvent: "mouseMoveEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 3, vars: 2, consts: [[1, "svg-container", 3, "id", "mousemove", "mouseenter", "mouseleave"], ["class", "svg-hover-point", 3, "width", "height", "left", "top", "dblclick", "click", "mousemove", 4, "ngIf"], [1, "svg-hover-point", 3, "dblclick", "click", "mousemove"]], template: function SvgContainerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("mousemove", function SvgContainerComponent_Template_div_mousemove_0_listener($event) { ctx.mouseInContainer = true; ctx.adjustPointPosition($event); return ctx.adjustMouseMovePosition($event); })("mouseenter", function SvgContainerComponent_Template_div_mouseenter_0_listener($event) { ctx.mouseInContainer = true; return ctx.mouseOverEvent.emit($event); })("mouseleave", function SvgContainerComponent_Template_div_mouseleave_0_listener($event) { ctx.mouseInContainer = false; return ctx.mouseOutEvent.emit($event); });
        ɵngcc0.ɵɵtemplate(1, SvgContainerComponent_div_1_Template, 1, 8, "div", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.containerId);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hoverable && ctx.mouseInContainer);
    } }, dependencies: [ɵngcc1.NgIf], styles: [".svg-hover-point[_ngcontent-%COMP%]{background-color:#000;border:1px solid #fff;border-radius:50%;position:absolute}.svg-container[_ngcontent-%COMP%]{position:relative}"] });
SvgContainerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
SvgContainerComponent.propDecorators = {
    containerId: [{ type: Input }],
    height: [{ type: Input }],
    showGrid: [{ type: Input }],
    grid: [{ type: Input }],
    hoverable: [{ type: Input }],
    pointSize: [{ type: Input }],
    viewBox: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    mouseMoveEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgContainerComponent, [{
        type: Component,
        args: [{ selector: 'svg-container', template: "<div [id]=\"containerId\" class=\"svg-container\"\n  (mousemove)=\"mouseInContainer = true; adjustPointPosition($event); adjustMouseMovePosition($event)\"\n  (mouseenter)=\"mouseInContainer = true; mouseOverEvent.emit($event)\"\n  (mouseleave)=\"mouseInContainer = false; mouseOutEvent.emit($event)\">\n  <div class=\"svg-hover-point\" (dblclick)=\"onPointDoubleClick()\"\n    (click)=\"onPointClick()\" (mousemove)=\"onPointHover()\"\n    [style.width.px]=\"pointSize\" [style.height.px]=\"pointSize\"\n    [style.left.px]=\"pointXCoordinate\" [style.top.px]=\"pointYCoordinate\"\n    *ngIf=\"hoverable && mouseInContainer\"></div>\n  \n  <ng-content></ng-content>\n</div>", styles: [".svg-hover-point{background-color:#000;border:1px solid #fff;border-radius:50%;position:absolute}.svg-container{position:relative}"] }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { height: [{
            type: Input
        }], showGrid: [{
            type: Input
        }], grid: [{
            type: Input
        }], hoverable: [{
            type: Input
        }], pointSize: [{
            type: Input
        }], viewBox: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], mouseMoveEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], containerId: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgRectDirective {
    /**
     * Create SVG Rect directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.color = '#000'; // Color of the rectangular background
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.rx = 0; // Radius for x axis.
        this.ry = 0; // Radius for y axis.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the rectangular directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates or updates the rectangular object within the container
     */
    ngAfterViewChecked() {
        // Check if container is created and no rectangular object is created
        if (this._svgContainer.getContainer() && !this._rect) {
            this.createRect();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._rect.remove();
    }
    /**
     * Is called when changes are made to the rect object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._rect) {
            // If we have already created the object, update it.
            this.updateRect();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update rectangular object within the SVG container.
     */
    updateRect() {
        this._rect
            .size(this.width, this.height) // Update the width and height
            .fill(this.color) // Update the color
            .radius(this.rx, this.ry) // Update the radius
            .move(this.x, this.y); // Update the coordinates
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create rectangular object within the SVG container.
     */
    createRect() {
        this._rect = this._svgContainer.getContainer()
            .rect(this.width, this.height) // Set height and width of the rect
            .fill(this.color) // Set fill color
            .move(this.x, this.y) // Set coordinates
            .radius(this.rx, this.ry) // Set radius
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the rect
        this.addRemoveClasses(this.classes);
        // Let's output the rect element
        this.onInitialize.emit(this._rect);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._rect.position() !== position) {
            this._rect.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the rect object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._rect
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._rect
                .addClass(classToAdd);
        }
    }
}
SvgRectDirective.ɵfac = function SvgRectDirective_Factory(t) { return new (t || SvgRectDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgRectDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgRectDirective, selectors: [["svg-rect"]], inputs: { color: "color", x: "x", y: "y", rx: "rx", ry: "ry", classes: "classes", height: "height", width: "width" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgRectDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgRectDirective.propDecorators = {
    height: [{ type: Input }],
    width: [{ type: Input }],
    color: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    rx: [{ type: Input }],
    ry: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgRectDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-rect'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], x: [{
            type: Input
        }], y: [{
            type: Input
        }], rx: [{
            type: Input
        }], ry: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgCircleDirective {
    /**
     * Create SVG Circle directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.color = '#000'; // Color of the circle background
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the circle directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates the circle object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no circle object is created
        if (this._svgContainer.getContainer() && !this._circle) {
            // If so, let's create a circle
            this.createCircle();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._circle.remove();
    }
    /**
     * Is called when changes are made to the circle object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._circle) {
            // If we have already created the object, update it.
            this.updateCircle();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update circle object within the SVG container.
     */
    updateCircle() {
        this._circle
            .size(this.diameter) // Set the diameter (twice the radius)
            .fill(this.color) // Set the fill color
            .attr('cx', +this.x + +this.diameter / 2) // Set x position
            .attr('cy', +this.y + +this.diameter / 2); // Set y position
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create circle object within the SVG container.
     */
    createCircle() {
        this._circle = this._svgContainer.getContainer()
            .circle(this.diameter) // Create the circle with diameter (twice the radius)
            .fill(this.color) // Set the fill color
            .attr('cx', +this.x + +this.diameter / 2) // Set x position
            .attr('cy', +this.y + +this.diameter / 2) // Set y position
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the circle
        this.addRemoveClasses(this.classes);
        // Let's output the circle element
        this.onInitialize.emit(this._circle);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._circle.position() !== position) {
            this._circle.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the circle object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._circle
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._circle
                .addClass(classToAdd);
        }
    }
}
SvgCircleDirective.ɵfac = function SvgCircleDirective_Factory(t) { return new (t || SvgCircleDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgCircleDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgCircleDirective, selectors: [["svg-circle"]], inputs: { color: "color", x: "x", y: "y", classes: "classes", diameter: "diameter" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgCircleDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgCircleDirective.propDecorators = {
    diameter: [{ type: Input }],
    color: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgCircleDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-circle'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], x: [{
            type: Input
        }], y: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], diameter: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgEllipseDirective {
    /**
     * Create SVG Ellipse directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.color = '#000'; // Color of the ellipse background
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the ellipse directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates or updates the ellipse object within the container
     */
    ngAfterViewChecked() {
        // Check if container is created and no ellipse object is created
        if (this._svgContainer.getContainer() && !this._ellipse) {
            this.createEllipse();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._ellipse.remove();
    }
    /**
     * Is called when changes are made to the ellipse object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._ellipse) {
            // If we have already created the object, update it.
            this.updateEllipse();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update ellipse object within the SVG container.
     */
    updateEllipse() {
        this._ellipse
            .size(this.width, this.height) // Update the width and height
            .fill(this.color) // Update the color
            .attr('cx', +this.x + +this.width / 2) // Set x position
            .attr('cy', +this.y + +this.height / 2); // Set y position
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create ellipse object within the SVG container.
     */
    createEllipse() {
        this._ellipse = this._svgContainer.getContainer()
            .ellipse(this.width, this.height) // Set height and width of the ellipse
            .fill(this.color) // Set fill color
            .attr('cx', +this.x + +this.width / 2) // Set x position
            .attr('cy', +this.y + +this.height / 2) // Set y position
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the ellipse
        this.addRemoveClasses(this.classes);
        // Let's output the ellipse element
        this.onInitialize.emit(this._ellipse);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._ellipse.position() !== position) {
            this._ellipse.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the ellipse object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._ellipse
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._ellipse
                .addClass(classToAdd);
        }
    }
}
SvgEllipseDirective.ɵfac = function SvgEllipseDirective_Factory(t) { return new (t || SvgEllipseDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgEllipseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgEllipseDirective, selectors: [["svg-ellipse"]], inputs: { color: "color", x: "x", y: "y", classes: "classes", height: "height", width: "width" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgEllipseDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgEllipseDirective.propDecorators = {
    height: [{ type: Input }],
    width: [{ type: Input }],
    color: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgEllipseDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-ellipse'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], x: [{
            type: Input
        }], y: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgLineDirective {
    /**
     * Create SVG Line directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.borderColor = '#000'; // Color of the line.
        this.x0 = 0; // Starting point on x axis.
        this.y0 = 0; // Starting point on y axis.
        this.x1 = 1; // Ending point on x axis.
        this.y1 = 1; // Ending point on y axis.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the line directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates or updates the line object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no line object is created
        if (this._svgContainer.getContainer() && !this._line) {
            this.createLine();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._line.remove();
    }
    /**
     * Is called when changes are made to the line object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._line) {
            // If we have already created the object, update it.
            this.updateLine();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update line object within the SVG container.
     */
    updateLine() {
        this._line
            .plot(this.x0, this.y0, this.x1, this.y1) // Create the line at specific position
            .stroke({ color: this.borderColor, width: this.borderSize }); // Set the border for the line
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create line object within the SVG container.
     */
    createLine() {
        this._line = this._svgContainer.getContainer()
            .line(this.x0, this.y0, this.x1, this.y1) // Create the line at specific position
            .stroke({ color: this.borderColor, width: this.borderSize }) // Set the border for the line
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the line
        this.addRemoveClasses(this.classes);
        // Let's output the line element
        this.onInitialize.emit(this._line);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._line.position() !== position) {
            this._line.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the line object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._line
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._line
                .addClass(classToAdd);
        }
    }
}
SvgLineDirective.ɵfac = function SvgLineDirective_Factory(t) { return new (t || SvgLineDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgLineDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgLineDirective, selectors: [["svg-line"]], inputs: { borderColor: "borderColor", x0: "x0", y0: "y0", x1: "x1", y1: "y1", classes: "classes", borderSize: "borderSize" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgLineDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgLineDirective.propDecorators = {
    borderSize: [{ type: Input }],
    borderColor: [{ type: Input }],
    x0: [{ type: Input }],
    y0: [{ type: Input }],
    x1: [{ type: Input }],
    y1: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgLineDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-line'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { borderColor: [{
            type: Input
        }], x0: [{
            type: Input
        }], y0: [{
            type: Input
        }], x1: [{
            type: Input
        }], y1: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], borderSize: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgPolylineDirective {
    /**
     * Create SVG Polyline directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.borderColor = '#000'; // Color of the polyline.
        this.fill = '#000'; // Color of the polyline body
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the polyline directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates or updates the polyline object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no polyline object is created
        if (this._svgContainer.getContainer() && !this._polyline) {
            this.createPolyline();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._polyline.remove();
    }
    /**
     * Is called when changes are made to the polyline object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._polyline) {
            // If we have already created the object, update it.
            this.updatePolyline();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update polyline object within the SVG container.
     */
    updatePolyline() {
        this._polyline
            .plot(this.points) // Update the polyline object
            .fill(this.fill) // Fill color of the polyline
            .stroke({ color: this.borderColor, width: this.borderSize }); // Set the border for the polyline
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create polyline object within the SVG container.
     */
    createPolyline() {
        this._polyline = this._svgContainer.getContainer()
            .polyline(this.points) // Create the polyline object
            .fill(this.fill) // Fill color of the polyline
            .stroke({ color: this.borderColor, width: this.borderSize }) // Set the border for the polyline
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the polyline
        this.addRemoveClasses(this.classes);
        // Let's output the polyline element
        this.onInitialize.emit(this._polyline);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._polyline.position() !== position) {
            this._polyline.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the polyline object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._polyline
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._polyline
                .addClass(classToAdd);
        }
    }
}
SvgPolylineDirective.ɵfac = function SvgPolylineDirective_Factory(t) { return new (t || SvgPolylineDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgPolylineDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgPolylineDirective, selectors: [["svg-polyline"]], inputs: { borderColor: "borderColor", fill: "fill", classes: "classes", points: "points", borderSize: "borderSize" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgPolylineDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgPolylineDirective.propDecorators = {
    points: [{ type: Input }],
    borderSize: [{ type: Input }],
    borderColor: [{ type: Input }],
    fill: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgPolylineDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-polyline'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { borderColor: [{
            type: Input
        }], fill: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], points: [{
            type: Input
        }], borderSize: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgPolygonDirective {
    /**
     * Create SVG Polygon directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.borderColor = '#000'; // Color of the polygon.
        this.fill = '#000'; // Color of the polygon body.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the polygon directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates or updates the polygon object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no polygon object is created
        if (this._svgContainer.getContainer() && !this._polygon) {
            this.createPolygon();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._polygon.remove();
    }
    /**
     * Is called when changes are made to the polygon object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._polygon) {
            // If we have already created the object, update it.
            this.updatePolygon();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update polygon object within the SVG container.
     */
    updatePolygon() {
        this._polygon
            .plot(this.points) // Update the polygon object
            .fill(this.fill) // Fill color of the polygon
            .stroke({ color: this.borderColor, width: this.borderSize }); // Set the border for the polygon
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create polygon object within the SVG container.
     */
    createPolygon() {
        this._polygon = this._svgContainer.getContainer()
            .polygon(this.points) // Create the polygon object
            .fill(this.fill) // Fill color of the polygon
            .stroke({ color: this.borderColor, width: this.borderSize }) // Set the border for the polygon
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the polygon
        this.addRemoveClasses(this.classes);
        // Let's output the polygon element
        this.onInitialize.emit(this._polygon);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._polygon.position() !== position) {
            this._polygon.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the polygon object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._polygon
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._polygon
                .addClass(classToAdd);
        }
    }
}
SvgPolygonDirective.ɵfac = function SvgPolygonDirective_Factory(t) { return new (t || SvgPolygonDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgPolygonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgPolygonDirective, selectors: [["svg-polygon"]], inputs: { borderColor: "borderColor", fill: "fill", classes: "classes", points: "points", borderSize: "borderSize" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgPolygonDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgPolygonDirective.propDecorators = {
    points: [{ type: Input }],
    borderSize: [{ type: Input }],
    borderColor: [{ type: Input }],
    fill: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgPolygonDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-polygon'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { borderColor: [{
            type: Input
        }], fill: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], points: [{
            type: Input
        }], borderSize: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgImageDirective {
    /**
     * Create SVG image directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.height = 100; // Height of the image.
        this.width = 100; // Width of the image.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the image directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates the image object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no image object is created
        if (this._svgContainer.getContainer() && !this._image) {
            this.createImage();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._image.remove();
    }
    /**
     * Is called when changes are made to the image object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        // Make sure we check it only when image is initialized
        if (this._image) {
            // Update image also in case image url has changed
            if (changes.imageUrl && changes.imageUrl.currentValue !== changes.imageUrl.previousValue) {
                // Update image properties and image itself
                this.updateImage(true);
            }
            else if ((changes.x && changes.x.currentValue !== changes.x.previousValue) ||
                (changes.y && changes.y.currentValue !== changes.y.previousValue) ||
                (changes.width && changes.width.currentValue !== changes.width.previousValue) ||
                (changes.height && changes.height.currentValue !== changes.height.previousValue)) {
                // Update only image properties
                this.updateImage(false);
            }
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update image object within the SVG container.
     * @param reloadImage - Boolean indicator if image should be reloaded.
     */
    updateImage(reloadImage) {
        // Check if we have to update only image properties, or also image itself
        if (reloadImage) {
            this._image
                .load(this.imageUrl) // Update image
                .size(this.width, this.height) // Update image size
                .move(this.x, this.y); // Update image position
        }
        else { // Update just image properties
            this._image
                .size(this.width, this.height) // Update image size
                .move(this.x, this.y); // Update image position
        }
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create image object within the SVG container.
     */
    createImage() {
        this._image = this._svgContainer.getContainer()
            .image() // Assign image object
            .load(this.imageUrl) // Load image
            .size(this.width, this.height) // Assign image size
            .move(this.x, this.y) // Assign position
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the image
        this.addRemoveClasses(this.classes);
        // Let's output the image element
        this.onInitialize.emit(this._image);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._image.position() !== position) {
            this._image.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the image object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._image
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._image
                .addClass(classToAdd);
        }
    }
}
SvgImageDirective.ɵfac = function SvgImageDirective_Factory(t) { return new (t || SvgImageDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgImageDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgImageDirective, selectors: [["svg-image"]], inputs: { x: "x", y: "y", height: "height", width: "width", classes: "classes", imageUrl: "imageUrl" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgImageDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgImageDirective.propDecorators = {
    imageUrl: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    height: [{ type: Input }],
    width: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgImageDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-image'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { x: [{
            type: Input
        }], y: [{
            type: Input
        }], height: [{
            type: Input
        }], width: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }], imageUrl: [{
            type: Input
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgPathDirective {
    /**
     * Create SVG Path directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        /**
         * Import variables for the path directive.
         */
        this.path = ''; // Path which needs to be displayed.
        this.borderColor = '#000'; // Color of the border.
        this.borderSize = 2; // Size of the border.
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.fill = ''; // Fill color of the path.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the path directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates the path object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no path object is created
        if (this._svgContainer.getContainer() && !this._path) {
            this.createPath();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._path.remove();
    }
    /**
     * Is called when changes are made to the path object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._path) {
            // If we have already created the object, update it.
            this.updatePath();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update path object within the SVG container.
     */
    updatePath() {
        this._path
            .plot(this.path) // Update the path for the element
            .stroke({ color: this.borderColor, width: this.borderSize }) // Update the border for the
            .fill(this.fill || 'rgba(0, 0, 0, 0)') // Update fill of the path
            .move(this.x, this.y); // Update the location of the path
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create path object within the SVG container.
     */
    createPath() {
        this._path = this._svgContainer.getContainer()
            .path(this.path) // Set the path for the element
            .stroke({ color: this.borderColor, width: this.borderSize }) // Set the border for the path
            .fill(this.fill || 'rgba(0, 0, 0, 0)') // Set fill of the path
            .move(this.x, this.y) // Set the location of the path
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the path
        this.addRemoveClasses(this.classes);
        // Let's output the path element
        this.onInitialize.emit(this._path);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._path.position() !== position) {
            this._path.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the path object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._path
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._path
                .addClass(classToAdd);
        }
    }
}
SvgPathDirective.ɵfac = function SvgPathDirective_Factory(t) { return new (t || SvgPathDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgPathDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgPathDirective, selectors: [["svg-path"]], inputs: { path: "path", borderColor: "borderColor", borderSize: "borderSize", x: "x", y: "y", fill: "fill", classes: "classes" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgPathDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgPathDirective.propDecorators = {
    path: [{ type: Input }],
    borderColor: [{ type: Input }],
    borderSize: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    fill: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgPathDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-path'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { path: [{
            type: Input
        }], borderColor: [{
            type: Input
        }], borderSize: [{
            type: Input
        }], x: [{
            type: Input
        }], y: [{
            type: Input
        }], fill: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }] }); })();

/**
 * Import Angular libraries.
 */
class SvgTextDirective {
    /**
     * Create SVG Text directive.
     * @param _svgContainer - Host SVG Container Component object instance.
     * @param _elRef - Angular element reference object instance.
     */
    constructor(_svgContainer, _elRef) {
        this._svgContainer = _svgContainer;
        this._elRef = _elRef;
        /**
         * Import variables for the text directive.
         */
        this.color = '#000'; // Color of the text.
        this.text = ''; // Text which needs to be displayed.
        this.x = 0; // Starting point on x axis.
        this.y = 0; // Starting point on y axis.
        this.size = 10; // Size of the text.
        this.classes = []; // List of CSS classes which needs to be added.
        /**
         * Output variables for the text directive.
         */
        this.clickEvent = new EventEmitter();
        this.doubleClickEvent = new EventEmitter();
        this.mouseOverEvent = new EventEmitter();
        this.mouseOutEvent = new EventEmitter();
        this.onInitialize = new EventEmitter();
    }
    /**
     * Creates the text object within the container.
     */
    ngAfterViewChecked() {
        // Check if container is created and no text object is created
        if (this._svgContainer.getContainer() && !this._text) {
            this.createText();
        }
    }
    /**
     * Does all required pre-requisites before destroying the component.
     */
    ngOnDestroy() {
        this._text.remove();
    }
    /**
     * Is called when changes are made to the text object.
     * @param changes - Angular Simple Changes object containing all of the changes.
     */
    ngOnChanges(changes) {
        if (this._text) {
            // If we have already created the object, update it.
            this.updateText();
            // Check if classes were changed
            if (changes.classes && changes.classes.currentValue !== changes.classes.previousValue) {
                // Get classes that needs to be removed
                const classesToRemove = changes.classes.previousValue.filter((previousClass) => !changes.classes.currentValue.some((currentClass) => currentClass === previousClass));
                // Get classes that needs to be added
                const classesToAdd = changes.classes.currentValue.filter((currentClass) => !changes.classes.previousValue.some((previousClass) => currentClass === previousClass));
                // Add and remove classes
                this.addRemoveClasses(classesToAdd, classesToRemove);
            }
        }
    }
    /**
     * Update text object within the SVG container.
     */
    updateText() {
        this._text
            .text(this.text) // Update the text for the element
            .fill(this.color) // Update the color of the text
            .font({
            size: this.size // Update the size of the text
        })
            .move(this.x, this.y); // Update the location of the text
        // Let's set element in a correct position
        this.setCorrectPosition();
    }
    /**
     * Create text object within the SVG container.
     */
    createText() {
        this._text = this._svgContainer.getContainer()
            .text(this.text) // Set the text for the element
            .fill(this.color) // Set the color of the text
            .font({
            size: this.size // Set the size of the text
        })
            .move(this.x, this.y) // Set the location of the text
            .on('click', (evt) => this.clickEvent.emit(evt)) // Assign click event
            .on('dblclick', (evt) => this.doubleClickEvent.emit(evt)) // Assign double click event
            .on('mouseover', (evt) => this.mouseOverEvent.emit(evt)) // Assign mouse over event
            .on('mouseout', (evt) => this.mouseOutEvent.emit(evt)); // Assign mouse out event
        // Let's set element in a correct position
        this.setCorrectPosition();
        // Add classes to the text
        this.addRemoveClasses(this.classes);
        // Let's output the text element
        this.onInitialize.emit(this._text);
    }
    /**
     * Sets correct position for the element.
     */
    setCorrectPosition() {
        // Find position of an element within the parent container
        const position = Array.prototype.slice.call(this._elRef.nativeElement.parentElement.children).indexOf(this._elRef.nativeElement);
        // Let's update and insert element in a correct position.
        if (this._svgContainer.getContainer().get(position) && this._text.position() !== position) {
            this._text.insertBefore(this._svgContainer.getContainer().get(position));
        }
    }
    /**
     * Adds classes to the text object.
     * @param classesToAdd - List of classes, which needs to be added.
     * @param classesToRemove - List of classes, which needs to be removed.
     */
    addRemoveClasses(classesToAdd, classesToRemove = []) {
        // First let's remove classes, that are not necessary anymore
        for (const classToRemove of classesToRemove) {
            this._text
                .removeClass(classToRemove);
        }
        // Now let's add new classes
        for (const classToAdd of classesToAdd) {
            this._text
                .addClass(classToAdd);
        }
    }
}
SvgTextDirective.ɵfac = function SvgTextDirective_Factory(t) { return new (t || SvgTextDirective)(ɵngcc0.ɵɵdirectiveInject(SvgContainerComponent), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SvgTextDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SvgTextDirective, selectors: [["svg-text"]], inputs: { color: "color", text: "text", x: "x", y: "y", size: "size", classes: "classes" }, outputs: { clickEvent: "clickEvent", doubleClickEvent: "doubleClickEvent", mouseOverEvent: "mouseOverEvent", mouseOutEvent: "mouseOutEvent", onInitialize: "onInitialize" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
SvgTextDirective.ctorParameters = () => [
    { type: SvgContainerComponent },
    { type: ElementRef }
];
SvgTextDirective.propDecorators = {
    color: [{ type: Input }],
    text: [{ type: Input }],
    x: [{ type: Input }],
    y: [{ type: Input }],
    size: [{ type: Input }],
    classes: [{ type: Input }],
    clickEvent: [{ type: Output }],
    doubleClickEvent: [{ type: Output }],
    mouseOverEvent: [{ type: Output }],
    mouseOutEvent: [{ type: Output }],
    onInitialize: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SvgTextDirective, [{
        type: Directive,
        args: [{
                selector: 'svg-text'
            }]
    }], function () { return [{ type: SvgContainerComponent }, { type: ɵngcc0.ElementRef }]; }, { color: [{
            type: Input
        }], text: [{
            type: Input
        }], x: [{
            type: Input
        }], y: [{
            type: Input
        }], size: [{
            type: Input
        }], classes: [{
            type: Input
        }], clickEvent: [{
            type: Output
        }], doubleClickEvent: [{
            type: Output
        }], mouseOverEvent: [{
            type: Output
        }], mouseOutEvent: [{
            type: Output
        }], onInitialize: [{
            type: Output
        }] }); })();

/**
 * Import Angular Libraries.
 */
class NgxSvgModule {
}
NgxSvgModule.ɵfac = function NgxSvgModule_Factory(t) { return new (t || NgxSvgModule)(); };
NgxSvgModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxSvgModule });
NgxSvgModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxSvgModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                exports: [
                    SvgContainerComponent,
                    SvgRectDirective,
                    SvgCircleDirective,
                    SvgEllipseDirective,
                    SvgLineDirective,
                    SvgPolylineDirective,
                    SvgPolygonDirective,
                    SvgImageDirective,
                    SvgPathDirective,
                    SvgTextDirective
                ],
                declarations: [
                    SvgContainerComponent,
                    SvgRectDirective,
                    SvgCircleDirective,
                    SvgEllipseDirective,
                    SvgLineDirective,
                    SvgPolylineDirective,
                    SvgPolygonDirective,
                    SvgImageDirective,
                    SvgPathDirective,
                    SvgTextDirective
                ],
                providers: []
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxSvgModule, { declarations: function () { return [SvgContainerComponent, SvgRectDirective, SvgCircleDirective, SvgEllipseDirective, SvgLineDirective, SvgPolylineDirective, SvgPolygonDirective, SvgImageDirective, SvgPathDirective, SvgTextDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [SvgContainerComponent, SvgRectDirective, SvgCircleDirective, SvgEllipseDirective, SvgLineDirective, SvgPolylineDirective, SvgPolygonDirective, SvgImageDirective, SvgPathDirective, SvgTextDirective]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NgxSvgModule, SvgContainerComponent as ɵa, SvgRectDirective as ɵb, SvgCircleDirective as ɵc, SvgEllipseDirective as ɵd, SvgLineDirective as ɵe, SvgPolylineDirective as ɵf, SvgPolygonDirective as ɵg, SvgImageDirective as ɵh, SvgPathDirective as ɵi, SvgTextDirective as ɵj };

